import { FC, useState } from 'react';
import { Product } from 'shared/types/product/Product';
import Button from 'components/commercetools-ui/atoms/button';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useAddToCartOverlay } from 'context/add-to-cart-overlay';
import useClassNames from 'helpers/hooks/useClassNames';
import { useFormat } from 'helpers/hooks/useFormat';
import { Variant } from 'types/entity/product';
import { AddItemResponse } from 'frontastic/hooks/useCart/types';
import useTrack from '../../hooks/useTrack';

export type QuickAddProps = {
  className?: string;
  buttonIsVisible: boolean;
  product: Product;
  onAddToCart?: (variant: Variant, quantity: number, subscriptions?: Variant[]) => Promise<AddItemResponse>;
};

const QuickAdd: FC<QuickAddProps> = ({ className, buttonIsVisible, product, onAddToCart }) => {
  const { formatMessage } = useFormat({ name: 'cart' });
  const [variant, setVariant] = useState(product?.variants[0]);
  const [quantity, setQuantity] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [added, setAdded] = useState(false);
  const { show } = useAddToCartOverlay();
  const { trackAddToCart } = useTrack({ product });

  const handleAddToCart = async () => {
    setLoading(true);

    onAddToCart?.(variant, quantity, []).then((res: AddItemResponse) => {
      setLoading(false);
      const defaultAddQty = 1;
      setAdded(true);
      setTimeout(() => {
        setAdded(false);
        setQuantity(defaultAddQty);
      }, 1000);

      show(product, variant, res.addQuantity, defaultAddQty);
    });
    trackAddToCart();
  };
  const classNames = useClassNames([className, buttonIsVisible ? 'block' : 'hidden']);
  return (
    <div className={classNames}>
      <Button
        className={`w-full !rounded-full py-8 text-center text-lg font-bold leading-snug hover:border-gray-800 hover:bg-gray-800 hover:text-white hover:shadow-none focus:border-gray-800 focus:bg-gray-800 focus:text-white active:border-gray-800 active:bg-gray-800 active:text-white`}
        variant="secondary"
        onClick={handleAddToCart}
        loading={loading}
        added={added}
        // disabled={!variant.isOnStock}
      >
        <Typography className="text-19 font-semibold">
          {formatMessage({ id: 'cart.add', defaultMessage: 'Add to cart' })}
        </Typography>
      </Button>
    </div>
  );
};

export default QuickAdd;
